const fake = () => Promise.resolve(false)

class SecureStorage {
  saveCredential = fake

  requestCredential = fake

  hasBiometry = fake

  resetCredential = fake
}

export default SecureStorage
